import React from 'react';
import { cn } from '@/lib/utils';

interface BrandVoicePillProps {
	brandVoice?: { id: string };
}

export function BrandVoicePill({ brandVoice }: BrandVoicePillProps) {
	if (!brandVoice) return null;

	const getBrandVoiceInfo = (id: string) => {
		switch (id) {
			case 'prometheus':
				return {
					label: 'Prometheus',
					emoji: '🔥',
					color: 'from-orange-400 to-orange-600',
				};
			case 'reverend':
				return {
					label: 'The Reverend',
					emoji: '🎭',
					color: 'from-purple-400 to-purple-600',
				};
			case 'brent':
				return {
					label: 'Brent Ecomm Master',
					emoji: '💼',
					color: 'from-blue-400 to-blue-600',
				};
			case 'user':
				return {
					label: 'My Brand Voice',
					emoji: '✨',
					color: 'from-emerald-400 to-emerald-600',
				};
			default:
				return {
					label: 'Unknown',
					emoji: '❓',
					color: 'from-gray-400 to-gray-600',
				};
		}
	};

	const info = getBrandVoiceInfo(brandVoice.id);
	return (
		<span
			className={cn(
				'px-2 py-1 rounded-full text-xs font-semibold bg-gradient-to-b text-white',
				info.color
			)}
		>
			<span className='text-inherit'>{info.emoji}</span> {info.label}
		</span>
	);
}
